// @flow

import React, { type Node } from 'react';
import { TipsBox } from '../../../../../commons/organisms';
import printTipSrc from './print-tip.svg';
import phoneTipSrc from './phone-tip.svg';
import calendarTipSrc from './calendar-tip.svg';
import duplifiedTipSrc from './duplified-tip.svg';
import styled from 'styled-components';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

export function CashTips(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch(country){
    case 'ar':
      return <ArgentineCashTips />;

    case 'mx':
      return <MexicanCashTips />;

    default:
      throw new Error(`Cash tips: message not mapped for country ${country}`);
  }
}

function ArgentineCashTips(): Node {
  return (
    <TipsWrapper>
      <TipsBox title="¡Importante saber!" tipsModel={[
        {
          imgSrc: calendarTipSrc,
          altText: 'calendar icon',
          tipText: 'La confirmación de pago puede demorar hasta 2 días hábiles para verse reflejado en Uber',
        },
        {
          imgSrc: duplifiedTipSrc,
          altText: 'do not pay duplicate icon',
          tipText: 'Este voucher es válido sólo para este pedido. Se realizas un pago duplicados, estos serán cancelados.',
        },
      ]}/>
    </TipsWrapper>
  );
}

function MexicanCashTips(): Node {
  return (
    <TipsWrapper>
      <TipsBox title="Consejos de pago!" tipsModel={[
        {
          imgSrc: printTipSrc,
          altText: 'payment method icon',
          tipText: 'Después de realizar tu pago, verifica que en el comprobante emitido por el cajero esté escrito “Cobro de EBANX”.',
        },
        {
          imgSrc: phoneTipSrc,
          altText: 'smartphone confirmation icon',
          tipText: 'La confirmación se realizará instantes después de completar el pago.',
        },
      ]}/>
    </TipsWrapper>
  );
}

const TipsWrapper = styled.div`
  margin: 10px;
`;
